<template>
	<table class="table table-bordered table-striped">
		<tbody>
			<tr>
				<th class="w-50">Összes bevétel [Ft]</th>
				<td class="text-end">{{ income.toLocaleString() }}</td>
			</tr>
			<tr>
				<th class="w-50">Kupon kedvezmények összesen [Ft]</th>
				<td class="text-end">{{ coupon_discount_sum.toLocaleString() }}</td>
			</tr>
			<tr>
				<th class="w-50">Kupon nélküli bevétel [Ft]</th>
				<td class="text-end">{{ income_without_coupons.toLocaleString() }}</td>
			</tr>
			<tr>
				<th class="w-50">Összes kupon [db]</th>
				<td class="text-end">{{ coupon_count.toLocaleString() }}</td>
			</tr>
			<tr>
				<th class="w-50">Összes foglalás [db]</th>
				<td class="text-end">{{ booking_count.toLocaleString() }}</td>
			</tr>
			<tr>
				<th class="w-50">Összes lemondott foglalás [db]</th>
				<td class="text-end">{{ cancelled_booking_count.toLocaleString() }}</td>
			</tr>
			<tr>
				<th class="w-50">Összes törölt foglalás [db]</th>
				<td class="text-end">{{ deleted_booking_count.toLocaleString() }}</td>
			</tr>
			<tr>
				<th class="w-50">Összes vendég (tag) [fő]</th>
				<td class="text-end">{{ guest_members.toLocaleString() }}</td>
			</tr>
			<tr>
				<th class="w-50">Összes vendég (turista) [fő]</th>
				<td class="text-end">{{ guest_non_members.toLocaleString() }}</td>
			</tr>
			<tr>
				<th class="w-50">Összes vendégéjszaka (tag) [vendégéjszaka]</th>
				<td class="text-end">{{ guest_member_nights.toLocaleString() }}</td>
			</tr>
			<tr>
				<th class="w-50">Összes vendégéjszaka (turista) [vendégéjszaka]</th>
				<td class="text-end">{{ guest_non_member_nights.toLocaleString() }}</td>
			</tr>
			<tr>
				<th class="w-50">Összes vendégéjszaka [db]</th>
				<td class="text-end">{{ sum_nights.toLocaleString() }}</td>
			</tr>
			<tr>
				<th class="w-50">Maximális kapacitás [vendég éjszaka]</th>
				<td class="text-end">{{ capacity.toLocaleString() }}</td>
			</tr>
			<tr>
				<th class="w-50">Kihasználtság [%]</th>
				<td class="text-end">{{ utilization.toLocaleString() }}</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
export default {
	props: {
		income: Number, 
		coupon_count: Number, 
		coupon_discount_sum: Number,
		booking_count: Number,
		cancelled_booking_count: Number,
		deleted_booking_count: Number,
		guest_members: Number,
		guest_member_nights: Number,
		guest_non_members: Number,
		guest_non_member_nights: Number,
		capacity: Number
	},
	computed: {
		income_without_coupons(){
			return this.income - this.coupon_discount_sum;
		},
		sum_nights(){
			return this.guest_member_nights + this.guest_non_member_nights;
		},
		utilization(){
			return (((this.guest_member_nights + this.guest_non_member_nights) / this.capacity)*100).toPrecision(2);
		}
	}
};
</script>
